// removed by extract-text-webpack-plugin
module.exports = {"modalWrapper":"_3PTLgL2A6ema-PWYRE98Cg","overlay":"_26LpGPwoIWXHUoHhH0kA_x","modal":"_9QpxUHsL3vkwTkjwoGLBl","title":"RQatkhlGDfMPm3ILWutbd","confirm":"_26mjBfUUZ1zpfcu-R-iWcJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.scss
// module id = 658
// module chunks = 0